export const GEMINI_LOGO_URL =
  'https://tii.imgix.net/global/gemini/gemini-text-logo-icon.png?auto=compress&h=48';

export const BLUEPRINT_DESCRIPTION =
  'The tools transforming the marketing industry, accelerating everything from research, to strategy, to asset creation, and more.';
